module.exports = __webpack_public_path__ + "static/media/buy_req_help_16.20e5170e.jpg";